import React from 'react';
import { PickListData } from '../pickPackTypes';
import { PickItemRow } from './PickItemRow';
import styles from './PickList.module.css';

interface PickListProps {
  pickList: PickListData;
  onPickedChange: (id: string, value: string) => void;
  onCompleteToggle: (id: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  // Whether this order has been confirmed yet. Pending orders must be confirmed
  // before they can be pick-packed.
  confirmed: boolean;
  onConfirmOrder: () => void;
  busy?: boolean;
}

export const PickList: React.FC<PickListProps> = ({
  pickList,
  onPickedChange,
  onCompleteToggle,
  onConfirm,
  onCancel,
  confirmed,
  onConfirmOrder,
  busy,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <h2 className={styles.title}>Pick List - {pickList.orderNumber}</h2>
          <p className={styles.customer}>Customer: {pickList.customerName}</p>
        </div>
        <span className={styles.priorityBadge}>{pickList.priority} Priority</span>
      </div>

      <div className={styles.itemsList}>
        {pickList.items.map((item) => (
          <PickItemRow
            key={item.id}
            item={item}
            onPickedChange={onPickedChange}
            onCompleteToggle={onCompleteToggle}
          />
        ))}
      </div>

      <div className={styles.actionBar}>
        {confirmed ? (
          <button className={styles.btnConfirm} onClick={onConfirm} disabled={busy}>
            Complete Pick &amp; Pack
          </button>
        ) : (
          <button className={styles.btnConfirm} onClick={onConfirmOrder} disabled={busy}>
            Confirm Order
          </button>
        )}
        <button className={styles.btnCancel} onClick={onCancel} disabled={busy}>
          Cancel
        </button>
      </div>
    </div>
  );
};
